import React from "react";
import { CustomText } from "../../../components";
import { fonts } from "../../../config";
import { masks } from "../../../utils";
import { StylesGuest } from "../styles";
import Grid from "@mui/material/GridLegacy";
import { SubmitButton } from "../../../components/newComponents";

function GuestConfirmStep({
  data,
  onSubmit,
}: {
  data: any;
  onSubmit: (v: any) => void;
}) {
  return (<StylesGuest.Container>
    <Grid container justifyContent="center">
      <CustomText
        style={{ paddingBottom: "25px", width: '100%' }}
        fontSize={1.75}
        fontFamily={fonts.bold}
        textColor="#8D9B9C"
      >
        DADOS DO LOCATÁRIO (PRIMÁRIO)
      </CustomText>

      <Grid container spacing={1}>
        <Grid item xs={12} sm={6}>
          <CustomText
            style={{ paddingBottom: "6px" }}
            fontSize={1.75}
            fontFamily={fonts.semibold}
            textColor="#4D585A"
          >
            NOME COMPLETO
          </CustomText>
          <CustomText
            style={{ paddingBottom: "6px" }}
            fontSize={2}
            fontFamily={fonts.semibold}
            textColor="#24272A"
          >
            {data?.primaryGuest?.name}
          </CustomText>
          <StylesGuest.Line />
        </Grid>

        <Grid item xs={12} sm={6}>
          <CustomText
            style={{ paddingBottom: "6px" }}
            fontSize={1.75}
            fontFamily={fonts.semibold}
            textColor="#4D585A"
          >
            DOCUMENTO
          </CustomText>
          <CustomText
            style={{ paddingBottom: "6px" }}
            fontSize={2}
            fontFamily={fonts.semibold}
            textColor="#24272A"
          >
            {data?.primaryGuest?.document
              ? masks.CPF(data?.primaryGuest?.document)
              : data?.primaryGuest?.passport}
          </CustomText>
          <StylesGuest.Line />
        </Grid>

        <Grid item xs={12} sm={6}>
          <CustomText
            style={{ paddingBottom: "6px" }}
            fontSize={1.75}
            fontFamily={fonts.semibold}
            textColor="#4D585A"
          >
            DATA NASCIMENTO
          </CustomText>
          <CustomText
            style={{ paddingBottom: "6px" }}
            fontSize={2}
            fontFamily={fonts.semibold}
            textColor="#24272A"
          >
            {masks.formatDate(data?.primaryGuest?.birthDate)}
          </CustomText>
          <StylesGuest.Line />
        </Grid>

        <Grid item xs={12} sm={6}>
          <CustomText
            style={{ paddingBottom: "6px" }}
            fontSize={1.75}
            fontFamily={fonts.semibold}
            textColor="#4D585A"
          >
            E-MAIL
          </CustomText>
          <CustomText
            style={{ paddingBottom: "6px" }}
            fontSize={2}
            fontFamily={fonts.semibold}
            textColor="#24272A"
          >
            {data?.primaryGuest?.email}
          </CustomText>
          <StylesGuest.Line />
        </Grid>

        {data?.primaryGuest?.phone && (
          <Grid item xs={12}>
            <CustomText
              style={{ paddingBottom: "6px" }}
              fontSize={1.75}
              fontFamily={fonts.semibold}
              textColor="#4D585A"
            >
              TELEFONE
            </CustomText>
            <CustomText
              style={{ paddingBottom: "6px" }}
              fontSize={2}
              fontFamily={fonts.semibold}
              textColor="#24272A"
            >
              {masks.inputMaskTELWithDDD(data?.primaryGuest?.phone)}
            </CustomText>
            <StylesGuest.Line />
          </Grid>
        )}
      </Grid>

      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "flex-end",
          marginTop: "24px",
        }}
      >
        <SubmitButton
          fullWidth={false}
          type="button"
          onClick={() => onSubmit({})}
        >
          Confirmar
        </SubmitButton>
      </div>


    </Grid></StylesGuest.Container>
  );
}

export default GuestConfirmStep;
